import { ApiClient, TranslationProvider, MapManager, MapNavigator } from "wonder-image";

window.ApiClient = ApiClient;
window.TranslationProvider = TranslationProvider;
window.MapManager = MapManager;
window.MapNavigator = MapNavigator;

window.API_CLIENT = new ApiClient(pathSite+'/api', API_TOKEN);
window.API_CLIENT_APP = window.API_CLIENT;

window.__t = function(key, replacements = []) {
    return TranslationProvider.get(key, replacements);
}